import Cookies from 'js-cookie'

const authTokenCookieKey = 'authToken';

const authTokenCookieOptions = () => ({
  path: '/',
  sameSite: 'Strict',
  secure: typeof window !== 'undefined' && window.location.protocol === 'https:',
});

export const authToken = () => {
  return Cookies.get(authTokenCookieKey);
}

export const setAuthToken = (token) => {
  return Cookies.set(authTokenCookieKey, token, authTokenCookieOptions());
}

export const clearAuthToken = () => {
  return Cookies.remove(authTokenCookieKey, authTokenCookieOptions());
}
